import ReactPlayer from "react-player"
import { Each } from "../../common/Each"
import styles from "./MacroMainPreview.module.css"
import typo from "../../typography.module.css"

const MacroMainPreview = ({ name, description, careers, video_url, thumbnail }) => {

    return (
        <div className={styles.main}>
            <div className={styles.macroLeft}>
                <div className={typo.subtitle}>Una carriera in {name}</div>
                <div className={styles.description}>{description}</div>
                <Each of={careers} render={(career) => {
                    return (
                        <button className={styles.careerButton}>{career.name}</button>
                    )
                }} />
            </div>
            <div className={styles.macroRight}>
                <div className={styles.playerWrapper}>
                    {
                        video_url &&
                        <ReactPlayer
                            url={video_url}
                            controls
                            width="100%"
                            height="100%"
                            className={styles.player}
                            light={thumbnail ?? ""}
                        />
                    }
                    {
                        !video_url && thumbnail &&
                        <img src={thumbnail} className={styles.macroThumbnail} alt="" />
                    }
                </div>
            </div>
        </div>
    )
}

export default MacroMainPreview